import FullscreenConfirm from "@pathwright/ui/src/components/confirm/FullscreenConfirm"
import { sizePropType } from "@pathwright/ui/src/components/utils/props"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import ProfileAvatarCardTrigger from "@pathwright/web/src/modules/profile/ProfileAvatarCardTrigger"
import { canEditLibrary } from "@pathwright/web/src/modules/user/permissions"
import { ConnectStores } from "lib/core/store"
import get from "lodash/get"
import MemberControls from "member/list/MemberControls"
import "./MembersCardRemove.css"
import { canInviteOrRemove } from "./utils"

const FacilitatorAvatarCard = function (props) {
  const {
    size,
    registration,
    canRemove,
    isRemoving,
    removeMember,
    unselectMemberForRemoval
  } = props

  const pwContext = usePathwrightContext()
  const { user } = registration

  return (
    <div>
      {isRemoving && (
        <FullscreenConfirm
          heading={`Are you sure you want to remove ${user.first_name} ${user.last_name}?`}
          body="This will remove all of their progress and access."
          confirmPrompt="Yes, Remove"
          cancelPrompt="Cancel"
          onCancel={unselectMemberForRemoval}
          onConfirm={() => removeMember({ id: registration.id }).promise}
        />
      )}
      <ProfileAvatarCardTrigger
        user={user}
        // TODO: expand perms for which users can view cohort staff profile?
        canViewProfile={canEditLibrary(pwContext)}
        size={size}
        placement="bottom"
        active={!isRemoving}
        renderDropdown={() => (
          <MemberControls member={registration} showEmail />
        )}
      />
    </div>
  )
}

FacilitatorAvatarCard.displayName = "FacilitatorAvatarCard"
FacilitatorAvatarCard.propTypes = {
  size: sizePropType
}
FacilitatorAvatarCard.defaultProps = {
  size: "3em"
}

const mapStateToProps = function (state, ownProps) {
  const { registration } = ownProps
  const { user } = state.authStore.state
  const { member_removing } = state.memberStore.state
  const { removeMember, selectMemberForRemoval, unselectMemberForRemoval } =
    state.memberStore.action
  const { permissions } = state.resourceStore.request
  const { mode } = state.pathStore.state
  // is this registration.user the same as the current user
  const sameAsUser = registration.user.id === get(user, "id")

  const canRemove =
    canInviteOrRemove(registration.role, permissions()) || sameAsUser
  const isRemoving =
    registration.id === member_removing &&
    // hacky workaround to ensure we only show confirmation modal if we're removing the member from the path (not from the members list)
    // This could (and should) be handled in state, but this works for now
    window.location.pathname.indexOf("/path/") > -1

  return _.assign(
    {},
    {
      canRemove,
      isRemoving,
      removeMember,
      selectMemberForRemoval,
      unselectMemberForRemoval
    },
    ownProps
  )
}

const stores = [
  { store: "auth", watch: false },
  { store: "path", watch: ["mode"] },
  { store: "resource", watch: ["offering"] },
  { store: "member", watch: ["member_removing"] }
]

export default ConnectStores(FacilitatorAvatarCard, stores, {}, mapStateToProps)
